<template>
<x-y-chart
  v-if="dataList[0]"
  :data-config="dataList[0]"
  :unit-prop="unitProp"
  chart-type="bar"
  :stack-type="0"
  data-time-format="MM月DD日HH时"
  download-name="PM2.5质量重构"
  chart-min-height="300px"
  chart-height="auto"
  style="height:100%;"
/>
</template>

<script>
import BaseCompare from './BaseCompare'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'
import DataFormatter from '../../../../model/DataFormatter'
import PM25QualityRefactor from '../../../../model/PM25QualityRefactor'
import {PROCESS_PANEL_SAVE} from '../EventKeys'

import XYChart from '../../../../components/DataChart/XYChart'

export default {
  name: 'AuditPmDeviceCompareChart',
  extends: BaseCompare,
  components: {XYChart},
  props: {
    conditions: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      unitProp: 'stdUnit'
    }
  },
  computed: {
    completeAllData: () => true,
    otherSiteDeviceCategoryConfigs () {
      let {filterReFactorFactors} = this

      return [
        new DeviceCategoryConfig(process.env.HEAVY_METAL_DEVICE_CATEGORY, false, filterReFactorFactors),
        new DeviceCategoryConfig(process.env.ION_DEVICE_CATEGORY, false, filterReFactorFactors),
        new DeviceCategoryConfig(process.env.OCEC_DEVICE_CATEGORY, false, filterReFactorFactors)
      ]
    }
  },
  methods: {
    filterCurrentSiteDeviceFactors (siteDeviceFactors) {
      return this.filterReFactorFactors(siteDeviceFactors)
    },
    filterReFactorFactors (siteDeviceFactors) {
      let {REFACTOR_ELEMENTS, REFACTOR_FACTOR_ID_MAP, REFACTOR_ELEMENT_MAP} = PM25QualityRefactor
      let qualityRatio = REFACTOR_ELEMENTS[REFACTOR_ELEMENTS.length - 2]
      let qualityRatioId = qualityRatio.id

      return Object.values(siteDeviceFactors.reduce((map, factor) => {
        let {factorId} = factor

        if (factorId === '1008') {
          map[qualityRatioId] = qualityRatio
        }

        let refactorElementId = REFACTOR_FACTOR_ID_MAP[factorId]

        if (refactorElementId && !map[refactorElementId]) {
          map[refactorElementId] = REFACTOR_ELEMENT_MAP[refactorElementId]
        }

        return map
      }, {}))
    },
    getSeriesParam (dimension, dimensionIds) {
      let factorId = dimensionIds[dimension ^ 1]

      if (factorId === 'pm25') {
        return {
          type: 'line',
          showSymbol: false
        }
      } else if (factorId === 'qualityRatio') {
        return {
          type: 'line',
          showSymbol: false,
          markLine: {
            name: '质量浓度比值控制限',
            lineStyle: {
              type: 'solid',
              color: 'red'
            },
            data: [{
              name: '质量浓度比值下线',
              yAxis: 0.7
            }, {
              name: '质量浓度比值上线',
              yAxis: 1.2
            }]
          }
        }
      } else {
        let siteId = dimensionIds[dimension]
        let param = {
          type: 'bar',
          stack: siteId,
          barMaxWidth: 30,
          showSymbol: false,
          color: PM25QualityRefactor.REFACTOR_ELEMENT_MAP[factorId].color,
          areaStyle: {}
        }

        return param
      }
    },
    processPanelSaveChange () {
      this.getData()
    },
    formatData: DataFormatter.format3,
    // filterDataList (dataList) {
    //   this.setDataList(dataList)
    // },
    getData () {
      this.changeLoadStatus(true)
      const { conditions } = this
      let currentQuery = JSON.parse(JSON.stringify(this.currentQuery))
      currentQuery.beginTime = conditions.beginTime
      currentQuery.endTime = conditions.endTime
      currentQuery.isGetInvalidData = false
      this.$api.QualityRestructure.getQualityData(currentQuery).then(this.setDataList).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    }
  },
  created () {
    this.$eventBus.on(PROCESS_PANEL_SAVE, this.processPanelSaveChange)
  },
  beforeDestroy () {
    let {$eventBus} = this
    $eventBus.off(PROCESS_PANEL_SAVE, this.processPanelSaveChange)
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditDeviceViews/AuditPmDeviceCompareChart.vue